import edenStatus from '@/utils/constants/edenStatus.js';

export const resolveStatusColor = (statusId) => {
    switch (statusId) {
        case edenStatus.NEW:
            return 'bg-secondary-15';
        case edenStatus.GENERATED_FILE:
            return 'bg-yellow-light';
        case edenStatus.SUBMITTED:
            return 'bg-green-light';
        case edenStatus.AMENDED:
            return 'bg-yellow-light';
        case edenStatus.PUBLISHED:
            return 'bg-green-light';
        default:
            return 'bg-green-light';
    }
};
